import { t } from 'i18next'
import type {
  LiquidProductOption,
  LiquidProduct,
  LiquidProductType,
} from '@/features/product/types/LiquidProduct'

export function mapProductOptionLabelOverride({
  totalLinkedBottoms,
  linkedBottom,
  option,
}: {
  totalLinkedBottoms: number
  linkedBottom: LiquidProduct
  option: LiquidProductOption
}): string | undefined {
  if (totalLinkedBottoms > 1) {
    const productTypeTitleMap: Partial<
      Record<LiquidProductType, string | undefined>
    > = {
      'Intimates Set Bottoms': t('product.bottoms_size'),
      'Intimates Set Skirt': t('product.skirt_size'),
    }

    if (productTypeTitleMap[linkedBottom.type]) {
      return productTypeTitleMap[linkedBottom.type]
    }
  }

  if (option.label && option.label !== option.name) {
    return option.label
  }
}
